var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"card-title-help dyor-logo",attrs:{"target":"_blank","href":_vm.link}},[_c('dyor-logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }